var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page"},[_c('van-button',{staticClass:"centered-button",staticStyle:{"width":"60%"},attrs:{"type":"primary","size":"large"},on:{"click":_vm.handleWxworkLogin}},[_vm._v(" 企业微信登录 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }